import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  TextField,
  Autocomplete,
  Box,
  Typography,
  IconButton,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  Tooltip,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
  FormGroup,
  FormControlLabel,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { CustomInputField } from "../CommonComponents/CustomCompontes";
import { dynamiceForm } from "../../actions/DynamiceForm";
import { companyWiseEmp } from "../../actions/Companywiseclient";
import InfoIcon from "@mui/icons-material/Info";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const UpdateType = [
  { type: true, name: "Save" },
  { type: true, name: "Update" },
  // { type: true, name: "Both" },
];
const PayloadType = [
  { type: true, name: "RequestBody" },
  { type: true, name: "FormData" },
];
const MethodType = [
  { type: true, name: "Post" },
  { type: true, name: "Put" },
];

const CompanyWiseApiDataSync = () => {
  const [leadTemplate, setLeadTemplate] = useState([]);
  const [apiUrl, setApiUrl] = useState("");
  const [jsonKey, setJsonKey] = useState("");
  const [staticValue, setStaticValue] = useState("");
  const [attendanceSelectType, setAttendanceSelectType] = useState(null);
  const [attendanceSelectTypeInputVal, setAttendanceSelectTypeInputVal] =
    useState("");
  const [isStaticValue, setIsStaticValue] = useState(false);
  const [apiPayloadType, setApiPayloadType] = useState(null);
  const [apiPayloadTypeInputVal, setApiPayloadTypeInputVal] = useState("");

  const [methodType, setMethodType] = useState(null);
  const [methodTypeInputVal, setMethodTypeInputVal] = useState("");

  const [formDataTemplateType, setFormDataTemplateType] = useState(null);
  const [formDataTemplateTypeInputVal, setFormDataTemplateTypeInputVal] =
    useState("");

  const [keyTemplatePairs, setKeyTemplatePairs] = useState([]);
  console.log("keyTemplatePairs", keyTemplatePairs);
  const [getAllApiDataSync, setGetAllApiDataSync] = useState(null);

  const [editData, setEditData] = useState(null);
  const [editPairIndex, setEditPairIndex] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedPayload, setSelectedPayload] = useState(null);

  const handleOpenDialog = (payloadDetails) => {
    setSelectedPayload(payloadDetails || []);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedPayload(null);
  };

  const companyId =
    JSON.parse(localStorage.getItem("CompanyIdSelect")) &&
    JSON.parse(localStorage.getItem("CompanyIdSelect")).id;

  const getTemplate = () => {
    const data = {
      companyId: companyId && companyId ? companyId : null,
      templateTypeId: 4,
    };

    dynamiceForm.fetchGetSaveTempalte(data).then((response) => {
      if (response !== null) {
        setLeadTemplate(JSON.parse(response.data.templateData));
      }
    });
  };

  const getApiDataSync = () => {
    const data = {
      companyId: companyId && companyId ? companyId : null,
    };
    dynamiceForm.fetchApiDataSync(data).then((response) => {
      if (response !== null) {
        setGetAllApiDataSync(response.data);
      }
    });
  };
  React.useEffect(() => {
    getTemplate();
    getApiDataSync();
  }, []);
  // name,label
  const formDataTemplateOptions = leadTemplate[0]?.children
    ? [
        ...(leadTemplate[0].children.column1 || []).map((item) => ({
          name: item.name,
          label: item.label,
          uid: item.uid,
        })),
        ...(leadTemplate[0].children.column2 || []).map((item) => ({
          name: item.name,
          label: item.label,
          uid: item.uid,
        })),
      ]
    : [];

  const handleAddPair = () => {
    if (
      jsonKey &&
      ((isStaticValue && staticValue) ||
        (!isStaticValue && formDataTemplateType))
    ) {
      const newPair = {
        jsonKey,
        template: isStaticValue ? null : formDataTemplateType,
        staticValue: isStaticValue ? staticValue : "",
        isStaticValue: isStaticValue,
      };

      if (editPairIndex !== null) {
        const updatedPairs = [...keyTemplatePairs];
        updatedPairs[editPairIndex] = newPair;
        setKeyTemplatePairs(updatedPairs);
        setEditPairIndex(null);
      } else {
        setKeyTemplatePairs([...keyTemplatePairs, newPair]);
      }

      setJsonKey("");
      setFormDataTemplateType(null);
      setFormDataTemplateTypeInputVal("");
      setStaticValue("");
      setIsStaticValue(false);
    }
  };
  // const handleEditPair = (index) => {
  //   const pair = keyTemplatePairs[index];
  //   setJsonKey(pair.jsonKey);
  //   setFormDataTemplateType(pair.template);
  //   setFormDataTemplateTypeInputVal(pair.template?.label || "");
  //   setEditPairIndex(index);
  // };
  const handleEditPair = (index) => {
    const pair = keyTemplatePairs[index];
    setJsonKey(pair.jsonKey);
    setIsStaticValue(pair.isStaticValue);
    if (pair.isStaticValue) {
      setStaticValue(pair.staticValue || "");
      setFormDataTemplateType(null);
      setFormDataTemplateTypeInputVal("");
    } else {
      setStaticValue("");
      setFormDataTemplateType(pair.template);
      setFormDataTemplateTypeInputVal(pair.template?.label || "");
    }
    setEditPairIndex(index);
  };

  const handleDeletePair = (index) => {
    if (window.confirm("Are you sure you want to delete this pair?")) {
      const updatedPairs = [...keyTemplatePairs];
      updatedPairs.splice(index, 1);
      setKeyTemplatePairs(updatedPairs);
    }
  };

  const syncThirdPartyApi = () => {
    if (apiUrl === "") {
      alert("Please enter your apiUrl!");
      return false;
    } else if (attendanceSelectType === null) {
      alert("Please enter your attendance type!");
      return false;
    } else if (attendanceSelectType === null) {
      alert("Please enter your attendance type!");
      return false;
    } else if (apiPayloadType === null) {
      alert("Please enter your api payload type!");
      return false;
    } else if (methodType === null) {
      alert("Please enter your api method type!");
      return false;
    }
    // else if (keyTemplatePairs.length() < 0) {
    //   alert("Please add key template pairs");
    //   return false;
    // }

    const isActive = !editData || (editData && editData.isActive !== false);
    const payload = {
      id: editData?.id || null,
      apiUrl,
      apiFor: attendanceSelectType?.name || null,
      apiPayloadType: apiPayloadType?.name || null,
      requestMethodType: methodType?.name || null,
      companyId: companyId && companyId ? companyId : null,
      isActive: isActive,
      payloadDetails: keyTemplatePairs.map((pair) => ({
        jsonKey: pair.jsonKey,
        formFieldName: pair?.template?.uid,
        // fieldName: pair?.template?.label,
        fieldName: pair?.template?.name,
        isStatic: pair?.isStaticValue,
        staticFieldValue: pair.isStaticValue ? pair.staticValue : null,
      })),
    };

    companyWiseEmp.thirdPartyApiSync(payload).then((response) => {
      if (response !== null && response?.responseCode == 200) {
        alert(response?.responseDescription);

        setApiUrl("");
        setAttendanceSelectType(null);
        setAttendanceSelectTypeInputVal("");
        setApiPayloadType(null);
        setApiPayloadTypeInputVal("");
        setMethodType(null);
        setMethodTypeInputVal("");
        setFormDataTemplateType(null);
        setFormDataTemplateTypeInputVal("");
        setJsonKey("");
        setKeyTemplatePairs([]);
        setEditData(null);
        setIsStaticValue(false);
        getApiDataSync();
      } else if (response !== null && response?.responseCode == 400) {
        alert(response?.responseDescription);
      }
    });
  };

  const handleEdit = (val) => {
    console.log("val", val);
    setEditData(val);

    setApiUrl(val?.apiUrl || "");

    const attendanceTypeObj = UpdateType.find(
      (item) => item.name === val?.apiFor
    );

    const payloadTypeObj = PayloadType.find(
      (item) => item.name === val?.apiPayloadType
    );
    const methodTypeObj = MethodType.find(
      (item) => item.name === val?.requestMethodType
    );

    setAttendanceSelectType(attendanceTypeObj || null);
    setAttendanceSelectTypeInputVal(val?.apiFor || "");
    setApiPayloadType(payloadTypeObj || null);
    setApiPayloadTypeInputVal(val?.apiPayloadType || "");
    setMethodType(methodTypeObj || null);
    setMethodTypeInputVal(val?.requestMethodType || "");

    const pairs =
      val?.payloadDetails?.map((p) => {
        const template = formDataTemplateOptions.find(
          (opt) => opt.uid === p.formFieldName
        );
        return {
          jsonKey: p.jsonKey,
          template,
          staticValue: p.staticFieldValue || "",
          isStaticValue: p.isStatic,
        };
      }) || [];

    setKeyTemplatePairs(pairs);
  };
  const handleCancel = () => {
    setApiUrl("");
    setAttendanceSelectType(null);
    setAttendanceSelectTypeInputVal("");
    setApiPayloadType(null);
    setApiPayloadTypeInputVal("");
    setMethodType(null);
    setMethodTypeInputVal("");
    setFormDataTemplateType(null);
    setFormDataTemplateTypeInputVal("");
    setJsonKey("");
    setKeyTemplatePairs([]);
    setEditData(null);
    setEditPairIndex(null);
    setIsStaticValue(false);
    setStaticValue("");
  };

  return (
    <React.Fragment>
      <Accordion className="main_accoardian" defaultExpanded={true}>
        <AccordionSummary
          className="accordianHeader"
          expandIcon={
            <AddCircleIcon fontSize="large" style={{ color: "white" }} />
          }
          aria-controls="panel1a-content"
          style={{
            background: "rgb(10 166 141)",
            borderRadius: "10px 10px 0px 0px",
            overflow: "hidden",
          }}
        >
          <Grid>
            <h3
              style={{
                color: "#fff",
                marginLeft: "10px",
                padding: "10px 2px",
              }}
            >
              Third Party API Sync:-
            </h3>
          </Grid>
        </AccordionSummary>

        <AccordionDetails className="accoardian_body">
          <Box sx={{ my: 1, mx: 1, py: 1 }}>
            <Grid
              container
              direction="row"
              //justifyContent="center"
              spacing={3}
              alignItems="center"
            >
              <Grid item spacing={3}>
                <CustomInputField
                  sx={{ width: "100%", margin: "0px !important" }}
                  required
                  value={apiUrl}
                  id="outlined-basic"
                  label="API Url "
                  name="apiUrl"
                  variant="outlined"
                  size="small"
                  onChange={(e) => setApiUrl(e.target.value)}
                />
              </Grid>

              <Grid item spacing={3}>
                <div className="field_box">
                  <Autocomplete
                    size="small"
                    className="select_box_forCompanyWise"
                    limitTags={1}
                    id="multiple-limit-tags"
                    options={UpdateType || []}
                    getOptionLabel={(option) => `${option.name}`}
                    disablePortal={true}
                    fullWidth
                    value={attendanceSelectType}
                    onChange={(e, newValue) => {
                      setAttendanceSelectType(newValue);
                    }}
                    inputValue={attendanceSelectTypeInputVal}
                    onInputChange={(e, newVal) =>
                      setAttendanceSelectTypeInputVal(newVal)
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        margin="dense"
                        placeholder="API Type"
                      />
                    )}
                  />
                </div>
              </Grid>
              <Grid item spacing={3}>
                <div className="field_box">
                  <Autocomplete
                    size="small"
                    className="select_box_forCompanyWise"
                    limitTags={1}
                    id="multiple-limit-tags"
                    options={PayloadType || []}
                    getOptionLabel={(option) => `${option.name}`}
                    disablePortal={true}
                    fullWidth
                    value={apiPayloadType}
                    onChange={(e, newValue) => {
                      setApiPayloadType(newValue);
                    }}
                    inputValue={apiPayloadTypeInputVal}
                    onInputChange={(e, newVal) =>
                      setApiPayloadTypeInputVal(newVal)
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        margin="dense"
                        placeholder="API Payload Type"
                      />
                    )}
                  />
                </div>
              </Grid>
              <Grid item spacing={3}>
                <div className="field_box">
                  <Autocomplete
                    size="small"
                    className="select_box_forCompanyWise"
                    limitTags={1}
                    id="multiple-limit-tags"
                    options={MethodType || []}
                    getOptionLabel={(option) => `${option.name}`}
                    disablePortal={true}
                    fullWidth
                    value={methodType}
                    onChange={(e, newValue) => {
                      setMethodType(newValue);
                    }}
                    inputValue={methodTypeInputVal}
                    onInputChange={(e, newVal) => setMethodTypeInputVal(newVal)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        margin="dense"
                        placeholder="HTTP Method Type"
                      />
                    )}
                  />
                </div>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              spacing={3}
              alignItems="center"
              sx={{ mt: 0.2 }}
            >
              <Grid item spacing={3}>
                <CustomInputField
                  sx={{ width: "100%", margin: "0px !important" }}
                  required
                  value={jsonKey}
                  id="outlined-basic"
                  label="JSON Key "
                  name="key"
                  variant="outlined"
                  size="small"
                  onChange={(e) => setJsonKey(e.target.value)}
                />
              </Grid>
              <Grid item spacing={3}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isStaticValue}
                        name="isStaticValue"
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setIsStaticValue(checked);
                          if (checked) {
                            setFormDataTemplateType(null);
                            setFormDataTemplateTypeInputVal("");
                          } else {
                            setStaticValue("");
                          }
                        }}
                      />
                    }
                    label="Is Static"
                  />
                </FormGroup>
              </Grid>
              {!Boolean(isStaticValue) && (
                <Grid item spacing={3}>
                  <div className="field_box">
                    <Autocomplete
                      size="small"
                      className="select_box"
                      limitTags={1}
                      id="multiple-limit-tags"
                      options={formDataTemplateOptions}
                      getOptionLabel={(option) => `${option.label} `}
                      disablePortal={true}
                      fullWidth
                      value={formDataTemplateType}
                      onChange={(e, newValue) => {
                        setFormDataTemplateType(newValue);
                      }}
                      inputValue={formDataTemplateTypeInputVal}
                      onInputChange={(e, newVal) =>
                        setFormDataTemplateTypeInputVal(newVal)
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          margin="dense"
                          placeholder="FormData Template Type"
                        />
                      )}
                    />
                  </div>
                </Grid>
              )}

              {Boolean(isStaticValue) && (
                <Grid item spacing={3}>
                  <CustomInputField
                    sx={{ width: "100%", margin: "0px !important" }}
                    required
                    value={staticValue}
                    id="outlined-basic"
                    label="Static Value "
                    name="key"
                    variant="outlined"
                    size="small"
                    onChange={(e) => setStaticValue(e.target.value)}
                  />
                </Grid>
              )}
              <Grid item spacing={3}>
                <IconButton
                  onClick={handleAddPair}
                  // disabled={!jsonKey || !formDataTemplateType}
                  sx={{ ml: 1 }}
                >
                  <AddCircleIcon style={{ color: "rgb(10 166 141)" }} />
                </IconButton>
              </Grid>
            </Grid>

            <Grid
              container
              direction="row"
              spacing={3}
              alignItems="center"
              sx={{ mt: 0.2 }}
            >
              <Grid item xs={8}>
                {keyTemplatePairs.length > 0 && (
                  <Box sx={{ mt: 2, mx: 1 }}>
                    <Typography
                      // variant="subtitle1"
                      sx={{ mb: 1, fontWeight: "bold" }}
                    >
                      Added Key-Template Pairs:
                    </Typography>
                    <Table
                      sx={{ backgroundColor: "#f5f5f5", borderRadius: "4px" }}
                      size="small"
                    >
                      <TableHead>
                        <TableRow
                          sx={{
                            backgroundColor: "rgb(10, 166, 141)",
                            borderTopLeftRadius: "4px",
                            borderTopRightRadius: "4px",
                          }}
                        >
                          <TableCell sx={{ fontWeight: "bold", color: "#fff" }}>
                            S.No.
                          </TableCell>
                          <TableCell sx={{ fontWeight: "bold", color: "#fff" }}>
                            JSON Key
                          </TableCell>
                          <TableCell
                            sx={{ fontWeight: "bold", color: "#fff" }}
                            align="center"
                          >
                            Template
                          </TableCell>
                          <TableCell
                            sx={{ fontWeight: "bold", color: "#fff" }}
                            align="center"
                          >
                            Static Value
                          </TableCell>
                          <TableCell sx={{ fontWeight: "bold", color: "#fff" }}>
                            Action
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {keyTemplatePairs.map((pair, index) => (
                          <TableRow key={index}>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>{pair.jsonKey}</TableCell>
                            <TableCell align="center">
                              {pair?.template?.label || "--"}
                            </TableCell>
                            <TableCell align="center">
                              {pair.staticValue || "--"}
                            </TableCell>
                            <TableCell>
                              <Tooltip title="Edit Added Key-Template Pairs">
                                <IconButton
                                  onClick={() => handleEditPair(index)}
                                >
                                  <EditIcon />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Delete Added Key-Template Pairs">
                                <IconButton
                                  onClick={() => handleDeletePair(index)}
                                >
                                  <DeleteIcon sx={{ color: "red" }} />
                                </IconButton>
                              </Tooltip>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </Box>
                )}
              </Grid>
            </Grid>

            <Grid
              container
              justifyContent="flex-end"
              alignItems="center"
              spacing={2}
              sx={{ pt: 1 }}
            >
              <Grid item>
                <div className="field_box">
                  <div
                    className="field_box_btn1"
                    onClick={syncThirdPartyApi}
                    style={{ cursor: "pointer", width: "60px" }}
                  >
                    {editData ? "Update" : "Save"}
                  </div>
                </div>
              </Grid>

              {Boolean(editData) && (
                <Grid item>
                  <div className="field_box">
                    <div
                      className="field_box_btn1"
                      onClick={handleCancel}
                      style={{ cursor: "pointer", width: "60px" }}
                    >
                      Cancel
                    </div>
                  </div>
                </Grid>
              )}
            </Grid>
            <Box sx={{ my: 1, py: 1 }}>
              <Grid
                container
                direction="row"
                alignItems="center"
                sx={{ mt: 0.2 }}
              >
                <TableContainer component={Paper}>
                  <Table size="small" aria-label="a dense table">
                    <TableHead
                      style={{ color: "#fff", backgroundColor: "#32577e" }}
                    >
                      <TableCell className="tabalecellStyle">S.no</TableCell>
                      <TableCell className="tabalecellStyle">Url</TableCell>
                      <TableCell className="tabalecellStyle">Type</TableCell>
                      <TableCell className="tabalecellStyle">
                        HTTP Method Type
                      </TableCell>
                      <TableCell className="tabalecellStyle">
                        Api Payload Type
                      </TableCell>
                      <TableCell align="center" className="tabalecellStyle">
                        Payload Details
                      </TableCell>
                      <TableCell align="center" className="tabalecellStyle">
                        Action
                      </TableCell>
                    </TableHead>
                    <TableBody>
                      {getAllApiDataSync &&
                        getAllApiDataSync.map((val, ind) => {
                          return (
                            <>
                              <TableRow>
                                <TableCell>{ind + 1}</TableCell>
                                <TableCell>{val?.apiUrl}</TableCell>
                                <TableCell>{val?.apiFor}</TableCell>
                                <TableCell>{val?.apiPayloadType}</TableCell>
                                <TableCell>{val?.requestMethodType}</TableCell>
                                <TableCell align="center">
                                  <Box>
                                    <Tooltip title="Payload Details">
                                      <IconButton
                                        onClick={() =>
                                          handleOpenDialog(val?.payloadDetails)
                                        }
                                      >
                                        <InfoIcon />
                                      </IconButton>
                                    </Tooltip>
                                  </Box>
                                </TableCell>
                                <TableCell align="center">
                                  <Tooltip title="Payload Details">
                                    <IconButton onClick={() => handleEdit(val)}>
                                      <EditIcon />
                                    </IconButton>
                                  </Tooltip>

                                  <Switch
                                    checked={val?.isActive !== false}
                                    onChange={(e) => {
                                      const updatedData = [
                                        ...getAllApiDataSync,
                                      ];
                                      updatedData[ind].isActive =
                                        e.target.checked;
                                      setGetAllApiDataSync(updatedData);
                                    }}
                                    color="secondary"
                                  />
                                </TableCell>
                              </TableRow>
                            </>
                          );
                        })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>
      <PayloadDetailsDialog
        open={openDialog}
        onClose={handleCloseDialog}
        payload={selectedPayload}
      />
    </React.Fragment>
  );
};

export default CompanyWiseApiDataSync;

const PayloadDetailsDialog = ({ open, onClose, payload }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography sx={{ fontWeight: "bold", fontSize: "1.2rem" }}>
          Payload Details
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        {payload && payload.length > 0 ? (
          <TableContainer component={Paper}>
            <Table size="small" aria-label="a dense table">
              <TableHead style={{ color: "#fff", backgroundColor: "#32577e" }}>
                <TableCell className="tabalecellStyle">Sl. No.</TableCell>
                <TableCell className="tabalecellStyle">JSON Key</TableCell>
                <TableCell className="tabalecellStyle">
                  Form Field Name
                </TableCell>
                <TableCell className="tabalecellStyle">
                  Static Field Value
                </TableCell>
              </TableHead>
              <TableBody>
                {payload.map((p, idx) => (
                  <TableRow key={idx}>
                    <TableCell>{idx + 1}</TableCell>
                    <TableCell>{p.jsonKey}</TableCell>
                    <TableCell>{p?.fieldName || "--"}</TableCell>
                    <TableCell>{p?.staticFieldValue || "--"}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Typography>No Payload Details Found</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
